import React from 'react';
import { Box } from '@mui/material';
import MaintenanceByVehicleDashboard from '../../components/maintenance/maintenanceVehicle/MaintenanceByVehicleDashboard';

const MantenimientosVehiculoPage = () => {  

  return (
    <Box sx={{ p: 2 }}>
      <MaintenanceByVehicleDashboard
        onReorder={(newOrder) => {
          console.log('Nuevo orden de mantenimientos por vehiculo:', newOrder);
        }}
      />
    </Box>
  );
};

export default MantenimientosVehiculoPage;